import React from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { Navigate } from "react-router-dom";

const AuthLayout = (props) => {
  // console.log("Local Storage Admin Info:", localStorage.getItem("strikes-shots-admin"));
  const isLoggedIn = localStorage.getItem("strikes-shots-admin");

  if (!isLoggedIn) {
    return <Navigate to="/admin-login" />;
  }
  return (
    <React.Fragment>
      <DashboardLayout>{props.children}</DashboardLayout>
    </React.Fragment>
  );
};

export default AuthLayout;
